import { Injectable, NgZone } from '@angular/core';
import { HttpInterceptorService } from './http-interceptor.service';
import { Router } from "@angular/router";


@Injectable()
export class HeartBeatService {

    private timer: number = null;
    private tokenValidity: number = null; //1800000; // 30 minutes
    private inactivityHeartBeatTimeframe: number = null; //240000; // 4 minutes
    private _timerCallback: () => void = this.aliveEventHandler.bind(this);

    constructor(private _http: HttpInterceptorService, private _ngZone: NgZone, private router: Router) { }

    public startHeartBeat() {
        if (this.tokenValidity && this.inactivityHeartBeatTimeframe) {
            this.setEventListeners();
        } else {
            this._http.get('/hb/settings')
                .subscribe((response: any) => {
                    this.tokenValidity = response.body.tokenValidity;
                    this.inactivityHeartBeatTimeframe = response.body.heartBeatThreshold;
                    this.setEventListeners();
                });
        }
    }

    public stopHeartBeat() {
        document.body.removeEventListener('keyup', this._timerCallback);
        document.body.removeEventListener('click', this._timerCallback);
    }

    private setEventListeners() {
        document.body.addEventListener("keyup", this._timerCallback);
        document.body.addEventListener("click", this._timerCallback);
    }

    private aliveEventHandler() {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }

        let heartBeatTimeToSend: number = this.getTimeToSendHb();

        // if we are past the point of heartbeat treshold
        if (heartBeatTimeToSend <= 0) {
            this.timeoutCallback();
        } else {
            // we have some time left on our hearbeat timer
            this.setTimeout(heartBeatTimeToSend);
        }
    }

    private getTimeToSendHb(): number {
        let timeoutCookie: string = this.retrieveTimeoutCookie();

        if (!timeoutCookie) {
          console.info(new Date().toUTCString() + ": heart-beat NO timeoutCookie");
            this.router.navigateByUrl('login');
            return;
        }
        let cookieValue: string = timeoutCookie.split("=")[1];
        let decodedCookie = decodeURIComponent(cookieValue);
        let tokeIssuedTime = decodedCookie.split('"')[1];
        let issuedEpoch: number = new Date(tokeIssuedTime).getTime();

        let validityTimeout = issuedEpoch + this.tokenValidity;
        let hbSendFrame = validityTimeout - this.inactivityHeartBeatTimeframe;

        let nowEpoch: number = (new Date()).getTime();
        return hbSendFrame - nowEpoch;
    }

    private retrieveTimeoutCookie() {
        let cookies = document.cookie.split("; ");
        return cookies.find(cookie => cookie.startsWith("HB"));
    }

    private setTimeout(inTime: number) {
        this._ngZone.runOutsideAngular(() => {
            this.timer = window.setTimeout(this.timeoutCallback.bind(this), inTime);
        })

    }

    private timeoutCallback() {
        this.sendHeartBeat().subscribe();
    }

    private sendHeartBeat() {
        return this._http.get(`/hb`);
    }

}
